function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import React, { useState, useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import { nanoid } from "nanoid";
import useTheme from "../hooks/useTheme";
import useBackground, { BackgroundProvider, mapResponsiveValues } from "../hooks/useBackground";
import useAccordion, { AccordionProvider } from "../hooks/useAccordion";
import useAccordionItem, { AccordionItemProvider } from "../hooks/useAccordionItem";
import { responsivePaddingType } from "../hooks/useResponsiveProp";
import useResponsivePropsCSS from "../hooks/useResponsivePropsCSS";
import { responsivePadding } from "../utils/css";
import { mergeProps } from "../utils/component";
import { hasOwnProperty } from "../utils/core";
import Icon from "./Icon";
import { jsx as ___EmotionJSX } from "@emotion/core";
var COLORS = ["grey.t07", "secondary.lightBlue.t25", "white"];
var TEXT_COLORS = ["black", "primary.blue.t100"];
var ITEM_GAP = ["small", "large"];
var ITEM_HEADER_AS = ["h2", "h3", "h4", "h5", "h6"];
var DEFAULT_PROPS = {
  color: "grey.t07",
  textColor: "black",
  itemHeaderAs: "h3",
  itemGap: "large"
};
Accordion.COLORS = COLORS;
Accordion.TEXT_COLORS = TEXT_COLORS;
Accordion.ITEM_GAP = ITEM_GAP;
Accordion.ITEM_HEADER_AS = ITEM_HEADER_AS;
Accordion.DEFAULT_PROPS = DEFAULT_PROPS;
function Header(_ref) {
  var children = _ref.children,
    testId = _ref.testId,
    _ref$__internal__keyb = _ref.__internal__keyboardFocus,
    __internal__keyboardFocus = _ref$__internal__keyb === void 0 ? false : _ref$__internal__keyb;
  var theme = useTheme();
  var _useAccordion = useAccordion(),
    colorMap = _useAccordion.colorMap,
    textColor = _useAccordion.textColor,
    HeaderComponent = _useAccordion.itemHeaderAs;
  var buttonCSS = useResponsivePropsCSS({}, {}, {
    backgroundColor: function backgroundColor(propsAtBreakpoint, theme, bp) {
      return theme.accordion.getCSS({
        targetElement: "headerButton",
        color: colorMap[bp],
        textColor: textColor,
        __internal__keyboardFocus: __internal__keyboardFocus
      });
    }
  });
  var _useAccordionItem = useAccordionItem(),
    headerId = _useAccordionItem.headerId,
    contentId = _useAccordionItem.contentId,
    isOpen = _useAccordionItem.isOpen,
    toggleAccordionItem = _useAccordionItem.toggleAccordionItem;
  var onClick = useCallback(function () {
    toggleAccordionItem();
  }, [toggleAccordionItem]);
  return ___EmotionJSX(HeaderComponent, {
    css: theme.accordion.getCSS({
      targetElement: "headerContainer"
    }),
    "data-testid": testId
  }, ___EmotionJSX("button", {
    id: headerId,
    css: buttonCSS,
    type: "button",
    "aria-controls": contentId,
    "aria-expanded": isOpen ? "true" : "false",
    onClick: onClick
  }, ___EmotionJSX("div", {
    css: theme.accordion.getCSS({
      targetElement: "headerContent"
    })
  }, children), ___EmotionJSX("div", {
    css: theme.accordion.getCSS({
      targetElement: "headerChevron",
      isOpen: isOpen
    })
  }, ___EmotionJSX(Icon, {
    name: "chevron-down",
    color: textColor
  }))));
}
Header.propTypes = {
  children: PropTypes.node.isRequired,
  testId: PropTypes.string,
  __internal__keyboardFocus: PropTypes.bool
};
function HeaderIcon(_ref2) {
  var name = _ref2.name,
    testId = _ref2.testId;
  var theme = useTheme();
  var _useAccordion2 = useAccordion(),
    textColor = _useAccordion2.textColor;
  return ___EmotionJSX("div", {
    css: theme.accordion.getCSS({
      targetElement: "headerIcon"
    }),
    "data-testid": testId
  }, ___EmotionJSX(Icon, {
    name: name,
    color: textColor
  }));
}
HeaderIcon.propTypes = {
  name: PropTypes.oneOf(Icon.NAMES).isRequired,
  testId: PropTypes.string
};
function Content(props) {
  var children = props.children,
    testId = props.testId;
  var theme = useTheme();
  var _useAccordion3 = useAccordion(),
    colorMap = _useAccordion3.colorMap;
  var bgMap = mapResponsiveValues(colorMap, theme.accordion.getContentColor, theme);
  var css = useResponsivePropsCSS(props, {}, {
    backgroundColor: function backgroundColor(propsAtBreakpoint, theme, bp) {
      return theme.accordion.getCSS({
        targetElement: "content",
        color: colorMap[bp]
      });
    },
    /* 
      Note: 
        `padding` needs to come after `backgroundColor` because 
        `backgroundColor` sets a default padding and we want to
        allow users to override it.
    */
    padding: responsivePadding
  });
  var _useAccordionItem2 = useAccordionItem(),
    headerId = _useAccordionItem2.headerId,
    contentId = _useAccordionItem2.contentId,
    isOpen = _useAccordionItem2.isOpen;
  return ___EmotionJSX(BackgroundProvider, {
    value: bgMap
  }, ___EmotionJSX("div", {
    id: contentId,
    css: css,
    role: "region",
    "aria-labelledby": headerId,
    hidden: !isOpen,
    "data-testid": testId
  }, children));
}
Content.propTypes = _objectSpread(_objectSpread({}, responsivePaddingType), {}, {
  children: PropTypes.node.isRequired,
  testId: PropTypes.string
});
var DEFAULT_ITEM_PROPS = {
  initiallyOpen: false
};
Item.DEFAULT_PROPS = DEFAULT_ITEM_PROPS;
function Item(props) {
  var theme = useTheme();
  var _useAccordion4 = useAccordion(),
    itemGap = _useAccordion4.itemGap;
  var _useState = useState(function () {
      return "accordion-item-header-".concat(nanoid());
    }),
    _useState2 = _slicedToArray(_useState, 1),
    headerId = _useState2[0];
  var _useState3 = useState(function () {
      return "accordion-item-content-".concat(nanoid());
    }),
    _useState4 = _slicedToArray(_useState3, 1),
    contentId = _useState4[0];
  var mergedProps = mergeProps(props, DEFAULT_ITEM_PROPS, {}, {
    initiallyOpen: function initiallyOpen(_initiallyOpen) {
      return typeof _initiallyOpen === "boolean";
    }
  });
  var initiallyOpen = mergedProps.initiallyOpen,
    children = mergedProps.children,
    testId = mergedProps.testId;
  var _useState5 = useState(initiallyOpen),
    _useState6 = _slicedToArray(_useState5, 2),
    isOpen = _useState6[0],
    setIsOpen = _useState6[1];
  var toggleAccordionItem = useCallback(function () {
    setIsOpen(function (isOpen) {
      return !isOpen;
    });
  }, []);
  var accordionItemInfo = useMemo(function () {
    return {
      headerId: headerId,
      contentId: contentId,
      isOpen: isOpen,
      toggleAccordionItem: toggleAccordionItem
    };
  }, [headerId, contentId, isOpen, toggleAccordionItem]);
  return ___EmotionJSX(AccordionItemProvider, {
    value: accordionItemInfo
  }, ___EmotionJSX("div", {
    css: theme.accordion.getCSS({
      targetElement: "item",
      itemGap: itemGap
    }),
    "data-testid": testId
  }, children));
}
Item.propTypes = {
  initiallyOpen: PropTypes.bool,
  children: PropTypes.node.isRequired,
  testId: PropTypes.string
};
function Accordion(props) {
  var theme = useTheme();
  var _useBackground = useBackground(),
    bgMap = _useBackground.bgMap;
  var mergedProps = mergeProps(props, DEFAULT_PROPS, {}, {
    color: function color(_color) {
      return COLORS.includes(_color);
    },
    textColor: function textColor(_textColor) {
      return TEXT_COLORS.includes(_textColor);
    },
    itemGap: function itemGap(_itemGap) {
      return ITEM_GAP.includes(_itemGap);
    },
    itemHeaderAs: function itemHeaderAs(_itemHeaderAs) {
      return ITEM_HEADER_AS.includes(_itemHeaderAs);
    }
  });
  var color = mergedProps.color,
    textColor = mergedProps.textColor,
    itemHeaderAs = mergedProps.itemHeaderAs,
    itemGap = mergedProps.itemGap,
    children = mergedProps.children,
    testId = mergedProps.testId;
  var colorMap = hasOwnProperty(props, "color") && hasOwnProperty(mergedProps, "color") ? mapResponsiveValues(bgMap, function () {
    return color;
  }, theme) : mapResponsiveValues(bgMap, function (backgroundColor) {
    return [undefined, "transparent", "white"].includes(backgroundColor) ? DEFAULT_PROPS.color : "white";
  }, theme);
  var accordionInfo = useMemo(function () {
    return {
      colorMap: colorMap,
      textColor: textColor,
      itemGap: itemGap,
      itemHeaderAs: itemHeaderAs
    };
  }, [colorMap, textColor, itemGap, itemHeaderAs]);
  return ___EmotionJSX(AccordionProvider, {
    value: accordionInfo
  }, ___EmotionJSX("div", {
    "data-testid": testId
  }, children));
}
Accordion.propTypes = {
  color: PropTypes.oneOf(COLORS),
  textColor: PropTypes.oneOf(TEXT_COLORS),
  itemGap: PropTypes.oneOf(ITEM_GAP),
  itemHeaderAs: PropTypes.oneOf(ITEM_HEADER_AS),
  children: PropTypes.node.isRequired,
  testId: PropTypes.string
};
Header.Icon = HeaderIcon;
Item.Header = Header;
Item.Content = Content;
Accordion.Item = Item;
export default Accordion;